import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import AskAkashWidget from "./components/AskAkashWidget";
import HomeHybrid from "./pages/HomeHybrid";
import Services from "./pages/Services";
import CaseStudies from "./pages/CaseStudies";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Newsletter from "./pages/Newsletter";
import Admin from "./pages/Admin";
import Consult from "./pages/Consult";
import ComingSoon from "./pages/ComingSoon";

const Chrome = () => {
  const { pathname } = useLocation();
  // /admin has its own layout; /consult is a purpose-built landing page (no site chrome, no chat widget).
  const hideChrome = pathname.startsWith('/admin') || pathname.startsWith('/consult');
  return (
    <>
      {!hideChrome && <Header />}
      <Routes>
        <Route path="/" element={<HomeHybrid />} />
        <Route path="/services" element={<Services />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/consult" element={<Consult />} />
        <Route path="/pricing" element={<ComingSoon pageName="Pricing" />} />
      </Routes>
      {!hideChrome && <AskAkashWidget />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Chrome />
      </BrowserRouter>
    </div>
  );
}

export default App;
